// import React, { useState } from "react";
// import { FaRobot, FaTimes, FaPaperPlane } from "react-icons/fa";
// import "./Chatbot.css";

// const Chatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { text: "Hello! How can I assist you today?", sender: "bot" },
//   ]);
//   const [input, setInput] = useState("");

//   // Sample chatbot responses
//   const handleSendMessage = () => {
//     if (input.trim() === "") return;

//     const userMessage = { text: input, sender: "user" };
//     const botReply = generateBotResponse(input);

//     setMessages([...messages, userMessage, botReply]);
//     setInput("");
//   };

//   const generateBotResponse = (question) => {
//     let response = "I'm not sure about that. Can you ask something else?";
    
//     const faq = {
//       "hello": "Hello! How can I assist you?",
//       "how are you": "I'm just a bot, but I'm here to help!",
//       "what is your name": "I'm your assistant chatbot.",
//       "what can you do": "I can answer questions and assist you with basic tasks.",
//     };

//     Object.keys(faq).forEach((key) => {
//       if (question.toLowerCase().includes(key)) {
//         response = faq[key];
//       }
//     });

//     return { text: response, sender: "bot" };
//   };

//   return (
//     <div>
//       {/* Chatbot Button */}
//       <button className="chatbot-button" onClick={() => setIsOpen(!isOpen)}>
//         {isOpen ? <FaTimes /> : <FaRobot />}
//       </button>

//       {/* Chatbot Window */}
//       {isOpen && (
//         <div className="chatbot-window">
//           <div className="chatbot-header">
//             <h3>Chatbot</h3>
//             <button onClick={() => setIsOpen(false)}><FaTimes /></button>
//           </div>
//           <div className="chatbot-body">
//             {messages.map((msg, index) => (
//               <div key={index} className={`chat-message ${msg.sender}`}>
//                 {msg.text}
//               </div>
//             ))}
//           </div>
//           <div className="chatbot-footer">
//             <input
//               type="text"
//               placeholder="Type your message..."
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
//             />
//             <button onClick={handleSendMessage}><FaPaperPlane /></button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Chatbot;


// import React, { useState } from "react";
// import { FaRobot, FaTimes, FaPaperPlane } from "react-icons/fa";
// import "./Chatbot.css";

// const Chatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { text: "Hello! How can I assist you today?", sender: "bot" },
//   ]);
//   const [input, setInput] = useState("");

//   const handleSendMessage = () => {
//     if (input.trim() === "") return;

//     const userMessage = { text: input, sender: "user" };
//     const botReply = generateBotResponse(input);

//     setMessages([...messages, userMessage, botReply]);
//     setInput("");
//   };

//   const generateBotResponse = (question) => {
//     let response = "I'm not sure about that. Can you ask something else?";
    
//     const faq = {
//       "hello": "Hello! How can I assist you?",
//       "how are you": "I'm just a bot, but I'm here to help!",
//       "what is your name": "I'm your assistant chatbot.",
//       "what can you do": "I can answer questions and assist you with basic tasks.",
//     };

//     Object.keys(faq).forEach((key) => {
//       if (question.toLowerCase().includes(key)) {
//         response = faq[key];
//       }
//     });

//     return { text: response, sender: "bot" };
//   };

//   return (
//     <div 
//       className="chatbot-container"
//       onMouseEnter={() => setIsOpen(true)}
//       onMouseLeave={() => setIsOpen(false)}
//     >
//       <button className="chatbot-icon">
//         <FaRobot />
//       </button>

//       {isOpen && (
//         <div className="chatbot-window">
//           <div className="chatbot-header">
//             <h3>Chatbot</h3>
//             <button onClick={() => setIsOpen(false)}><FaTimes /></button>
//           </div>
//           <div className="chatbot-body">
//             {messages.map((msg, index) => (
//               <div key={index} className={`chat-message ${msg.sender}`}>
//                 {msg.text}
//               </div>
//             ))}
//           </div>
//           <div className="chatbot-footer">
//             <input
//               type="text"
//               placeholder="Type your message..."
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
//             />
//             <button onClick={handleSendMessage}><FaPaperPlane /></button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Chatbot;


import React, { useState } from "react";
import { FaRobot, FaTimes, FaPaperPlane } from "react-icons/fa";
import "./Chatbot.css";

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hello! How can I assist you today?", sender: "bot" },
  ]);
  const [input, setInput] = useState("");

  const handleSendMessage = () => {
    if (input.trim() === "") return;

    const userMessage = { text: input, sender: "user" };
    const botReply = generateBotResponse(input);

    setMessages([...messages, userMessage, botReply]);
    setInput("");
  };

  const generateBotResponse = (question) => {
    let response = "I'm not sure about that. Can you ask something else?";
    
    const faq = {
      "hello": "Hello! How can I assist you?",
      "how are you": "I'm just a bot, but I'm here to help!",
      "what is your name": "I'm your assistant chatbot.",
      "what can you do": "I can answer questions and assist you with basic tasks.",
    };

    Object.keys(faq).forEach((key) => {
      if (question.toLowerCase().includes(key)) {
        response = faq[key];
      }
    });

    return { text: response, sender: "bot" };
  };

  return (
    <div 
      className="chatbot-container"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className="chatbot-icon">
        <FaRobot className="robot-icon" />
      </div>

      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <h3>AI Assistant</h3>
            <button onClick={() => setIsOpen(false)}><FaTimes /></button>
          </div>
          <div className="chatbot-body">
            {messages.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
          </div>
          <div className="chatbot-footer">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
            />
            <button onClick={handleSendMessage}><FaPaperPlane /></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
